module.exports = __webpack_public_path__ + "img/album15_07.8816bd4e.jpg";